var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.21 229.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:24px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 114.61,
    cy: 114.61,
    rx: 102.61,
    ry: 41.36,
    transform: "translate(-0.46 228.75) rotate(-89.77)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 114.61,
    cy: 114.61,
    rx: 41.36,
    ry: 102.61,
    transform: "translate(-0.46 228.75) rotate(-89.77)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatEnergy);
export default __webpack_public_path__ + "static/media/stat-energy.0094d2cbf50c699f9233e6cc3e2b0c94.svg";
export { ForwardRef as ReactComponent };